module.exports = __webpack_public_path__ + "./assets/img_osakaShinsaibashi_grey__76c62f7d2537fcefdc6f27acc2ce63d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_osakaShinsaibashi_grey.jpg
// module id = 644
// module chunks = 12